import { DateRange } from 'bold-ui'
import { isUndefinedOrNull } from 'util/checks'

export interface LocalDateRange {
  startDate?: LocalDate
  endDate?: LocalDate
}

export type DateRangeFieldType = LocalDateRange | DateRange

export function isLocalDateRange(range: DateRangeFieldType): range is LocalDateRange {
  return (
    !isUndefinedOrNull(range) &&
    (typeof range.startDate === 'string' || isUndefinedOrNull(range.startDate)) &&
    (typeof range.endDate === 'string' || isUndefinedOrNull(range.endDate))
  )
}

export function isDateRange(range: DateRangeFieldType): range is DateRange {
  return (
    !isUndefinedOrNull(range) &&
    (typeof range.startDate === 'object' || isUndefinedOrNull(range.startDate)) &&
    (typeof range.endDate === 'object' || isUndefinedOrNull(range.endDate))
  )
}
